import { createContext, useContext } from 'react'

import { ChatCompactionStatus } from '@/types/chat-v2'

// Lives outside ChatRuntimeProvider so leaf consumers (MarkdownText, the
// compaction indicators) don't pull the whole runtime module into their
// import chain.
export const ChatCompactionStatusContext =
  createContext<ChatCompactionStatus>('idle')

export const useChatCompactionStatus = () =>
  useContext(ChatCompactionStatusContext)
